import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  imgTitle: {
    width: 777,
    height: 451,
    alignSelf: "center",
    marginVertical: 40,
  },
  viewDetail: {
    marginVertical: 20,
    marginHorizontal: width * 0.1,
  },
  textSubject: {
    fontSize: 28,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  viewEvent: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textGenderEvent: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textItemEvent: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDate: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonRegister: {
    width: 201,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    marginTop: 25,
  },
  textRegister: {
    fontSize: 25,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
});
